import { type AccessByLinkOrTeam, ReasonAccess } from "@/appInterface/windows/shareWindow/types.js";

type HtmlElementType = HTMLDivElement | HTMLInputElement | Element;

export function InitAccessToggles(func) {
    const accessToggles = document.getElementsByClassName("unionAccessToggle");
    for (let i = 0; i < accessToggles.length; i++) {
        const isReadonly = accessToggles[i].classList.contains("unionAccessToggleReadOnly");
        const isInited = accessToggles[i].getAttribute("isInited");
        if ((isInited == null || !isInited) && !isReadonly) {
            accessToggles[i].setAttribute("isInited", "true");
            accessToggles[i].addEventListener("mousedown", func, false);
        }
    }
}

const PASSWORD_REG = /^(?=(.*[a-zA-Z]))/;

export function validatePassword(password: string) {
    let errorText = "";
    if (!password) {
        errorText = "Введите пароль";
    } else if (password.length > 50) {
        errorText = "Максимальная длина пароля 50 символов";
    } else if (password.length < 4) {
        errorText = "Длина пароля от 4 символов";
    } else if (!PASSWORD_REG.test(password)) {
        errorText = "Пароль должен содержать хотя бы одну букву латинского алфавита";
    }

    return {
        hasError: !!errorText,
        errorText,
    };
}

export function getAccessReadable(access: AccessByLinkOrTeam) {
    if (access === "edit") {
        return "Редактор";
    }
    if (access === "view") {
        return "Читатель";
    }
    if (access === "view_copy") {
        return "Читатель \n(копирование)";
    }
    if (access === "denied") {
        return "Без доступа";
    }
    if (access === "owner") {
        return "Владелец";
    }

    return "";
}

export function getTargetLocal(e: Event, className: string): HtmlElementType | null {
    let elem: HtmlElementType | null = null;
    const path = e.composedPath();
    for (let i = 0; i < path.length; i++) {
        const classesList = (path[i] as HtmlElementType).classList;
        if (classesList === undefined) return elem;
        if (classesList.contains(className)) {
            elem = path[i] as Element;
            break;
        }
    }
    return elem;
}

export function getCandidatesList() {
    const list: string[] = [];
    const bubbles = document.querySelectorAll(".shareWindowShareAdditionalBubblesItem");

    for (let i = 0; i < bubbles.length; i++) {
        const memberEmail = bubbles[i].getAttribute("candidateEmail") || "";
        list.push(memberEmail);
    }

    return list;
}

export function notify(text: string, notificator?: (text: string) => void) {
    if (notificator) {
        notificator(text);
    }
}

export function getMenuConfigsByAccess(reason: string) {
    if (reason === "teamAccess") {
        return [
            { name: "Редактор", code: "edit", toSet: true },
            { name: "Читатель", code: "view", toSet: true },
            { name: "Читатель \n(копирование)", code: "view_copy", toSet: true },
            { name: "Без доступа", code: "denied", toSet: true },
        ];
    }
    if (reason === "publicAccess") {
        return [
            { name: "Редактор", code: "edit", toSet: true },
            { name: "Читатель", code: "view", toSet: true },
            { name: "Читатель \n(копирование)", code: "view_copy", toSet: true },
            { name: "Без доступа", code: "denied", toSet: true },
        ];
    }
    if (reason === "memberAccess") {
        return [
            { name: "Редактор", code: "edit", toSet: true },
            { name: "Читатель", code: "view", toSet: true },
            { name: "Читатель \n(копирование)", code: "view_copy", toSet: true },
            { name: "Удалить", code: "delete", toSet: false },
        ];
    }
    if (reason === "searchAccess") {
        return [
            { name: "Редактор", code: "edit", toSet: true },
            { name: "Читатель", code: "view", toSet: true },
            { name: "Читатель \n(копирование)", code: "view_copy", toSet: true },
        ];
    }

    return [];
}

export function getAccessMenuData(reason: string, onlyRead: boolean) {
    const configs = getMenuConfigsByAccess(reason);
    if (!onlyRead) return configs;
    const onlyReadAccess = ["view", "denied", "delete"];

    return configs.filter((item) => onlyReadAccess.includes(item.code));
}
